export { VitalsAggregateMergedResult, VitalsApi } from './VitalsApi';
